import React from "react";

const Footer = () => (
	<footer className="bg-red-950 text-white py-6 mt-10">
		<div className="text-center text-sm">
			&copy; {new Date().getFullYear()} Inovativa Company Limited. All rights
			reserved.
		</div>
	</footer>
);

export default Footer;
